<template>
  <div class="box11">
    <pageTitle 
      title="阿里云ACP认证考试流程" 
      text=""
      titleColor="#332114"
      titColor="#332114"
    />
    <div class="wapper">
      <div class="box">
        <a class="item item1" href="https://m.boxuegu.com/course/detail-10051" target="_blank">
          <h2>01</h2>
          <p>购买课程</p>
          <i></i>
        </a>
        <div class="item">
          <h2>02</h2>
          <p>开通课程权限进入学习</p>
        </div>
        <div class="item">
          <h2>03</h2>
          <p>考试预约</p>
        </div>
        <div class="item item4">
          <h2>04</h2>
          <div>
            <p>现场考试</p>
            <p class="desc">阿里云官方合作伙伴</p>
            <p class="desc">报考学生有线上考试特权</p>
          </div>
        </div>
        <div class="item">
          <h2>05</h2>
          <p>领取证书</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pageTitle from "../common/pageTitle.vue";
  export default {
    components: {
      pageTitle,
    },
    name: '',
    data() {
      return {
        
      }
    }
  }
</script>

<style lang="scss" scoped>
.box11{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/acp/box11/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.wapper {
  padding: 50px 30px 0 30px;
  .box {
    padding-left: 60px;
    background: url(../../../assets/coursePage/acp/box11/step.png) no-repeat;
    background-size: auto 100%;
  }
  
  .item {
    height: 86px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0px 0px 30px 0px #f5e9dc;
    border-radius: 20px;
    margin-bottom: 30px;
    h2 {
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      font-weight: 600;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #ffd2b2;
      margin: 0 20px 0 40px;
    }
    p {
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: 600;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #332114;
      &.desc {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #332114;
      }
    }
    &.item1 {
      position: relative;
      i {
        display: block;
        width: 93px;
        height: 22px;
        background: url(../../../assets/coursePage/acp/box11/icon-arrow.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 40px;
        top: 32px;
      }
    }
    &.item4 {
      height: 164px;
      h2 {
        margin-top: -78px;
      }
      div > p:first-of-type {
        margin-bottom: 8px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>